export const PAYGO_API_BASE_URL =  process.env.REACT_APP_BACKEND_API_URL + "/api/v1/paygos";